export const projectsName = {
  firstName: 'Nom Du Projet',

  secondName: 'Nom Du Projet',
};

export const portfolioText =
 "Une fois que la maison a été accordée d'un certificat d'achèvement par le conseil et approuvée par votre agent, vous pouvez vous allonger sur votre canapé soigneusement choisi et admirer votre magnifique nouvelle maison. La période de défauts - où l'entrepreneur est obligé de corriger tout problème - durera normalement 12 mois."
